import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { head } from 'lodash'

import {
  Button,
  Col,
  Container,
  Image,
  Modal,
  Row,
  Spinner
} from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import logo from '../../../images/drivers-clearinghouse-logo-small.png'

import * as actions from '../../../actions'

class GeneratePDFExcel extends Component {
  state = {
    files: []
  }

  componentDidMount () {
    this.props.setProcessedFMCSAList()
    this.props.setError()
  }

  _renderButtonContents () {
    const { driversBulkActions: { loading } } = this.props
    if (!loading) { return 'Upload' }
    return <React.Fragment>
      <Spinner animation='border' size='sm' className='align-middle mr-2'></Spinner>
      Uploading
    </React.Fragment>
  }

  _renderInstructions () {
    const { driversBulkActions: { processedFMCSAList } } = this.props
    if (processedFMCSAList) { return '' }
    return (
      <Row>
        <Col xs={12}>
          <p>Please ensure the uploaded Excel document is the FMCSA query results document.  Otherwise, you will experience errors with this process.</p>
        </Col>
      </Row>
    )

  }

  _renderDropzone () {
    const { driversBulkActions: { processedFMCSAList } } = this.props
    if (processedFMCSAList) { return '' }

    const { files } = this.state
    let text = <span>Drag and drop an <strong>Excel</strong> file here or click to select a file.</span>
    if (files.length === 1) {
      text = <span>
        File to be uploaded: <strong>{files[0].name}</strong><br></br>
        Click upload to continue, or choose a different file.
      </span>
    }

    return (
      <Row>
        <Col xs={12} className='d-flex justify-content-center align-items-center'>
          <Dropzone
            multiple={false}
            onDrop={(files) => this.setState({ files })}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <div {...getRootProps({ className: `dropzone ${isDragActive ? 'active' : ''} p-3 d-flex justify-content-center align-items-center` })} style={{ width: '100%' }}>
                <input {...getInputProps()} />
                {text}
              </div>
            )}
          </Dropzone>
        </Col>
      </Row>
    )
  }

  _renderProcessed () {
    const { driversBulkActions: { processedFMCSAList, error } } = this.props
    if (!processedFMCSAList && !error) { return '' }
    if (processedFMCSAList && processedFMCSAList.success && processedFMCSAList.message) {
      return (
        <>
          <Row>
            <Col xs={12} className='alert alert-success'>
              {processedFMCSAList.message}
            </Col>
          </Row>
          <Row>
            <Col xs={12} className='d-flex justify-content-center'>
              <Button
                variant='link'
                className='p-0 align-baseline'
                onClick={() => this.props.history.push('/company-admin/fmcsa-bulk-upload-list')}
              >
                View FMCSA Bulk Upload List
              </Button>
            </Col>
          </Row>
        </>
      )
    }

    // Show error if present
    if (error) {
      return (
        <Row>
          <Col xs={12} className='alert alert-danger'>
            {error}
          </Col>
        </Row>
      )
    }

    return ''
  }

  render () {
    const { driversBulkActions: { loading, processedFMCSAList }, done } = this.props
    const { files } = this.state

    return (
      <Modal
        show={true}
        onHide={() => done()}
        animation={false}
        size='lg'
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Image className='mr-3' src={logo} height={26} width={39} alt='logo' />
            Generate PDFs from Excel file
          </Modal.Title>
          <div>
            <Button
              size='sm'
              variant='outline-secondary'
              title='Close'
              className='ml-2'
              onClick={() => done()}
            ><FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {this._renderInstructions()}
            {this._renderDropzone()}
            {this._renderProcessed()}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            size={'sm'}
            className={processedFMCSAList ? 'btn-wide' : 'btn-semi-wide'}
            onClick={() => done()}
          >{processedFMCSAList ? 'Done' : 'Cancel'}</Button>
          {processedFMCSAList ? '' :
            <Button
              variant='primary'
              size={'sm'}
              disabled={loading || files.length !== 1}
              className='btn-wide'
              onClick={() => this.props.processFMCSAList(head(this.state.files))}
            >{this._renderButtonContents()}</Button>
          }
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  const { auth, driversBulkActions } = state
  return { auth, driversBulkActions }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { ...actions.driversBulkActions },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GeneratePDFExcel))

GeneratePDFExcel.propTypes = {
  done: PropTypes.func.isRequired,
  driversBulkActions: PropTypes.object.isRequired,
  setProcessedFMCSAList: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  processFMCSAList: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
}
